<template>
  <li class="wf-flex wf-justify-between wf-py-1">
    <span class="wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">fixed</span>
    <div>
      <toggle-button sync v-model="fixed"/>
    </div>
  </li>
</template>

<script>
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      fixed: {
        get() {
          return !! this.elementClasses(this.classes)[this.device].find(constant => constant.value == 'FIXED_TRUE')
        },
        set(value) {
          if (value) {
            return this.addToArray(this.module, [{property: 'Fixed', value: 'FIXED_TRUE', touched: false}], this.classes, this.device, {}, true, this.parentModule)
          }
          return this.addToArray(this.module, [{property: 'Fixed', value: 'FIXED_FALSE', touched: false}], this.classes, this.device, {}, true, this.parentModule)
        }
      },
    }
  })
</script>